module.exports = __webpack_public_path__ + "assets/img/046401.f77dfc85.png";